"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var idlUtils = require("../generated/utils");

var isFormElement = require("../generated/HTMLFormElement").isImpl;

var closest = require("../helpers/traversal").closest;

var isDisabled = require("../helpers/form-controls").isDisabled;

var isSubmittable = require("../helpers/form-controls").isSubmittable;

var isButton = require("../helpers/form-controls").isButton;

var normalizeToCRLF = require("../helpers/form-controls").normalizeToCRLF;

var Blob = require("../generated/Blob.js");

var File = require("../generated/File.js");

var conversions = require("webidl-conversions");

exports.implementation = /*#__PURE__*/function () {
  function FormDataImpl(args) {
    _classCallCheck(this, FormDataImpl);

    this._entries = [];

    if (args[0] !== undefined) {
      if (!isFormElement(args[0])) {
        throw new TypeError("First argument must undefined or a HTMLFormElement");
      }

      this._entries = constructTheFormDataSet(args[0]);
    }
  }

  _createClass(FormDataImpl, [{
    key: "append",
    value: function append(name, value, filename) {
      // Handling this manually for now: https://github.com/jsdom/webidl2js/issues/29
      if (!Blob.isImpl(value)) {
        value = conversions.USVString(value);
      }

      var entry = createAnEntry(name, value, filename);

      this._entries.push(entry);
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      this._entries = this._entries.filter(function (entry) {
        return entry.name !== name;
      });
    }
  }, {
    key: "get",
    value: function get(name) {
      var foundEntry = this._entries.find(function (entry) {
        return entry.name === name;
      });

      return foundEntry !== undefined ? foundEntry.value : null;
    }
  }, {
    key: "getAll",
    value: function getAll(name) {
      return this._entries.filter(function (entry) {
        return entry.name === name;
      }).map(function (entry) {
        return entry.value;
      });
    }
  }, {
    key: "has",
    value: function has(name) {
      return this._entries.findIndex(function (entry) {
        return entry.name === name;
      }) !== -1;
    }
  }, {
    key: "set",
    value: function set(name, value, filename) {
      // Handling this manually for now: https://github.com/jsdom/webidl2js/issues/29
      if (!Blob.isImpl(value)) {
        value = conversions.USVString(value);
      }

      var entry = createAnEntry(name, value, filename);

      var foundIndex = this._entries.findIndex(function (e) {
        return e.name === name;
      });

      if (foundIndex !== -1) {
        this._entries[foundIndex] = entry;
        this._entries = this._entries.filter(function (e, i) {
          return e.name !== name || i === foundIndex;
        });
      } else {
        this._entries.push(entry);
      }
    }
  }]);

  return FormDataImpl;
}();

function createAnEntry(name, value, filename) {
  var entry = {
    name: name
  }; // https://github.com/whatwg/xhr/issues/75

  if (Blob.isImpl(value) && !File.isImpl(value)) {
    var oldValue = value;
    value = File.createImpl([[], "blob", {
      type: oldValue.type
    }]); // "representing the same bytes"

    value._buffer = oldValue._buffer;
  }

  if (File.isImpl(value) && filename !== undefined) {
    var _oldValue = value;
    value = File.createImpl([[], filename, // spec makes no mention of `lastModified`; assume it is inherited
    // (Chrome's behavior)
    {
      type: _oldValue.type,
      lastModified: _oldValue.lastModified
    }]); // "representing the same bytes"

    value._buffer = _oldValue._buffer;
  }

  entry.value = value;
  return entry;
}

function constructTheFormDataSet(form, submitter) {
  // https://html.spec.whatwg.org/multipage/forms.html#constructing-form-data-set
  var controls = Array.prototype.filter.call(form.elements, isSubmittable); // submittable is a subset of listed

  var formDataSet = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = controls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var fieldWrapper = _step.value;
      var field = idlUtils.implForWrapper(fieldWrapper);

      if (closest(field, "datalist") !== null) {
        continue;
      }

      if (isDisabled(field)) {
        continue;
      }

      if (isButton(field) && field !== submitter) {
        continue;
      }

      if (field.type === "checkbox" && field._checkedness === false) {
        continue;
      }

      if (field.type === "radio" && field._checkedness === false) {
        continue;
      }

      if (field.type !== "image" && (!field.hasAttribute("name") || field.getAttribute("name") === "")) {
        continue;
      }

      if (field.localName === "object") {
        // in jsdom, no objects are "using a plugin"
        continue;
      }

      var type = field.type; // Omit special processing of <input type="image"> since so far we don't actually ever pass submitter

      var nameAttr = field.getAttribute("name");
      var name = nameAttr === null ? "" : nameAttr;

      if (field.localName === "select") {
        for (var i = 0; i < field.options.length; ++i) {
          var option = idlUtils.implForWrapper(field.options[i]);

          if (option._selectedness === true && !isDisabled(field)) {
            formDataSet.push({
              name: name,
              value: option.value,
              type: type
            });
          }
        }
      } else if (field.localName === "input" && (type === "checkbox" || type === "radio")) {
        var value = field.hasAttribute("value") ? field.getAttribute("value") : "on";
        formDataSet.push({
          name: name,
          value: value,
          type: type
        });
      } else if (type === "file") {
        for (var _i2 = 0; _i2 < field.files.length; ++_i2) {
          formDataSet.push({
            name: name,
            value: field.files.item(_i2),
            type: type
          });
        }

        if (field.files.length === 0) {
          formDataSet.push({
            name: name,
            value: "",
            type: "application/octet-stream"
          });
        }
      }
      /* skip plugins */
      else {
          formDataSet.push({
            name: name,
            value: field._getValue(),
            type: type
          });
        }

      var dirname = field.getAttribute("dirname");

      if (dirname !== null && dirname !== "") {
        var dir = "ltr"; // jsdom does not (yet?) implement actual directionality

        formDataSet.push({
          name: dirname,
          value: dir,
          type: "direction"
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  for (var _i = 0, _formDataSet = formDataSet; _i < _formDataSet.length; _i++) {
    var entry = _formDataSet[_i];
    entry.name = conversions.USVString(normalizeToCRLF(entry.name));

    if (entry.type !== "file" && entry.type !== "textarea") {
      entry.value = normalizeToCRLF(entry.value);
    }

    if (entry.type !== "file") {
      entry.value = conversions.USVString(entry.value);
    }
  }

  return formDataSet;
}